import React from 'react'
import { FormGroup, Label, Input } from 'reactstrap'
import InstanceSearchButton from './InstanceSearchButton'

function InstanceSearchInput({ value, onChange, onSearch }) {
  return (
    <FormGroup className="page-size-control">
      <Label for="instanceSearch" className="">
        Buscar instancia
      </Label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Input
          type="text"
          name="instanceSearch"
          id="instanceSearch"
          className="page-size-select"
          placeholder="Buscar por nombre..."
          value={value}
          onChange={onChange}
        />
        <InstanceSearchButton onSearch={onSearch} />
      </div>
      
    </FormGroup>
  )
}

export default InstanceSearchInput
